module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('creams-form', {
    attrs: {
      "cream": _vm.cream,
      "alert": _vm.alert
    },
    on: {
      "submit": _vm.onSubmit,
      "delete": _vm.onDelete
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9588aaf2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/frontend/components/pages/creams/edit.vue
// module id = 121
// module chunks = 1